import { createContext } from 'react';
import type { AuthMeResponse } from '@/api/auth.api';

export type AuthState =
  | { status: 'loading' }
  | { status: 'unauthenticated' }
  | { status: 'authenticated'; me: AuthMeResponse };

export interface AuthContextValue {
  state: AuthState;
  /** Force a refresh from the server — call after login/logout. */
  refresh: () => Promise<void>;
  /** Convenience: clear cookie + local state. */
  signOut: () => Promise<void>;
  /**
   * Switch the active organization — re-mints the session cookie server-side,
   * then re-hydrates local state. Callers are responsible for clearing any
   * org-scoped caches (e.g. `queryClient.clear()`) afterwards.
   */
  switchOrg: (organizationId: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
